/* assets/tb-hero-rotator.js
   Created 2025.12.23 to support section tb-hero-rotating-heading.liquid
   - Roller mode: line-by-line vertical roll across all headlines (including wrapped lines)
   - Fade fallback
*/

(function () {
  function prefersReducedMotion() {
    return !!(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches);
  }

  function toInt(v, fallback) {
    var n = parseInt(v, 10);
    return isFinite(n) && n > 0 ? n : fallback;
  }

  function clearTimers(root) {
    if (root._tbRotatorTimer) {
      clearInterval(root._tbRotatorTimer);
      root._tbRotatorTimer = null;
    }
    if (root._tbRotatorResizeT) {
      clearTimeout(root._tbRotatorResizeT);
      root._tbRotatorResizeT = null;
    }
  }

  function getAutoplay(root) {
    var autoplayAttr = root.getAttribute("data-rotate-autoplay");
    return autoplayAttr === null ? true : autoplayAttr === "true";
  }

  function getLineHeightPx(h1El) {
    var cs = window.getComputedStyle(h1El);
    var lh = cs.lineHeight;
    var px = 0;
    if (lh && lh.indexOf("px") > -1) px = parseFloat(lh);
    if (!px || px < 10) {
      var fs = parseFloat(cs.fontSize) || 16;
      px = Math.round(fs * 1.2);
    }
    return px;
  }

  function buildLinesForText(text, widthPx, h1El) {
    text = (text || "").trim();
    if (!text) return [];

    var meas = document.createElement("span");
    meas.setAttribute("aria-hidden", "true");
    meas.style.position = "absolute";
    meas.style.visibility = "hidden";
    meas.style.pointerEvents = "none";
    meas.style.left = "-9999px";
    meas.style.top = "0";
    meas.style.display = "inline-block";
    meas.style.whiteSpace = "normal";
    meas.style.wordBreak = "break-word";
    meas.style.width = widthPx + "px";

    var cs = window.getComputedStyle(h1El);
    meas.style.fontFamily = cs.fontFamily;
    meas.style.fontSize = cs.fontSize;
    meas.style.fontWeight = cs.fontWeight;
    meas.style.letterSpacing = cs.letterSpacing;
    meas.style.textTransform = cs.textTransform;
    meas.style.lineHeight = cs.lineHeight;

    document.body.appendChild(meas);

    var words = text.split(/\s+/).filter(Boolean);
    var lines = [];
    var current = "";
    var prevHeight = 0;

    for (var i = 0; i < words.length; i++) {
      var test = current ? current + " " + words[i] : words[i];
      meas.textContent = test;

      var h = meas.scrollHeight;
      if (prevHeight && h > prevHeight) {
        lines.push(current);
        current = words[i];
        meas.textContent = current;
        prevHeight = meas.scrollHeight;
      } else {
        current = test;
        prevHeight = h;
      }
    }

    if (current) lines.push(current);

    document.body.removeChild(meas);
    return lines;
  }

  function ensureRoller(root, wrap, items) {
    var h1 = wrap.closest("h1");
    if (!h1) return null;

    // Measure against real caption content width (prevents “only a couple words” issue)
    var caption = root.querySelector(".caption-content");
    var width = caption && caption.getBoundingClientRect().width
      ? caption.getBoundingClientRect().width
      : h1.getBoundingClientRect().width;

    width = Math.max(40, Math.floor(width - 2));
    if (!width || width < 40) return null;

    var lineHeightPx = getLineHeightPx(h1);

    var frames = [];
    for (var i = 0; i < items.length; i++) {
      var txt = (items[i].textContent || "").trim();
      if (!txt) continue;
      var lines = buildLinesForText(txt, width, h1);
      for (var k = 0; k < lines.length; k++) if (lines[k]) frames.push(lines[k]);
    }
    if (frames.length < 2) return null;

    var existing = wrap.querySelector("[data-tb-roller]");
    if (existing) existing.parentNode.removeChild(existing);

    var roller = document.createElement("span");
    roller.className = "tb-roller";
    roller.setAttribute("data-tb-roller", "");
    roller.style.height = lineHeightPx + "px";

    var track = document.createElement("span");
    track.className = "tb-roller__track";
    track.setAttribute("data-tb-roller-track", "");

    for (var f = 0; f < frames.length; f++) {
      var line = document.createElement("span");
      line.className = "tb-roller__line";
      line.textContent = frames[f];
      line.style.height = lineHeightPx + "px";
      line.style.lineHeight = lineHeightPx + "px";
      track.appendChild(line);
    }

    roller.appendChild(track);
    wrap.appendChild(roller);

    return { roller: roller, track: track, frames: frames, lineHeightPx: lineHeightPx };
  }

  function init(root) {
    if (!root) return;

    clearTimers(root);

    var wrap = root.querySelector("[data-tb-rotator-wrap]");
    if (!wrap) return;

    // IMPORTANT: only read items inside THIS rotator wrap
    var items = wrap.querySelectorAll("[data-tb-rotator-item]");
    if (!items || items.length < 2) return;

    var rotateMs = toInt(root.getAttribute("data-rotate-ms"), 2400);
    if (rotateMs < 1200) rotateMs = 2400;

    var mode = (root.getAttribute("data-rotate-mode") || "roller").toLowerCase();

    if (mode === "roller") {
      wrap.classList.add("is-roller");

      var built = ensureRoller(root, wrap, items);
      if (built) {
        if (prefersReducedMotion()) return;
        if (!getAutoplay(root)) return;

        var idx = 0;

        requestAnimationFrame(function () {
          built.roller.classList.add("is-animating");
        });

        function tick() {
          idx = (idx + 1) % built.frames.length;
          built.track.style.transform =
            "translate3d(0," + -idx * built.lineHeightPx + "px,0)";
        }

        setTimeout(function () {
          if (!root || !root.isConnected) return;
          tick();
        }, 700);

        root._tbRotatorTimer = setInterval(tick, rotateMs);

        window.addEventListener("resize", function () {
          clearTimeout(root._tbRotatorResizeT);
          root._tbRotatorResizeT = setTimeout(function () {
            if (!root || !root.isConnected) return;
            init(root);
          }, 200);
        });

        return;
      }

      wrap.classList.remove("is-roller");
    }

    // Fade fallback
    if (prefersReducedMotion()) return;
    if (!getAutoplay(root)) return;

    var activeIndex = 0;
    for (var j = 0; j < items.length; j++) {
      if (items[j].classList.contains("is-active")) {
        activeIndex = j;
        break;
      }
    }

    function tickFade() {
      items[activeIndex].classList.remove("is-active");
      activeIndex = (activeIndex + 1) % items.length;
      items[activeIndex].classList.add("is-active");
    }

    setTimeout(tickFade, 700);
    root._tbRotatorTimer = setInterval(tickFade, rotateMs);
  }

  function initAllIn(container) {
    if (!container) return;
    var nodes = container.querySelectorAll("[data-tb-rotator]");
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }

  // Initial load
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAllIn(document);
    });
  } else {
    initAllIn(document);
  }

  // Theme Editor support
  document.addEventListener("shopify:section:load", function (event) {
    if (!event || !event.target) return;
    initAllIn(event.target);
  });

  // Optional: re-init on section select (nice for editor)
  document.addEventListener("shopify:section:select", function (event) {
    if (!event || !event.target) return;
    initAllIn(event.target);
  });
})();